import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  HStack,
  Link,
  Text,
} from "@chakra-ui/react"
import type { FC, ReactNode } from "react"

import type { SimulationResultType } from "@/proposal/components/simulation/common/SimulationResultBadge"
import SimulationResultBadge from "@/proposal/components/simulation/common/SimulationResultBadge"

type Props = {
  title: string
  children: ReactNode
  learnMoreLink?: { url: string; label: string }
  result?: SimulationResultType
  hasTransparentBackground?: boolean
}
const ReportSection: FC<Props> = ({
  title,
  children,
  learnMoreLink,
  result,
  hasTransparentBackground = false,
}) => {
  return (
    <AccordionItem
      bgColor="white"
      borderColor={hasTransparentBackground ? "gray.50" : "gray.200"}
      borderRadius="md"
      borderWidth={hasTransparentBackground ? "1px 1px 0 1px" : "1px"}
      mb={3}
    >
      <AccordionButton
        _hover={{
          borderRadius: "md",
          backgroundColor: "gray.100",
        }}
        borderBottomColor="gray.200"
        borderBottomRadius={hasTransparentBackground ? "md" : "auto"}
        borderTopRadius={hasTransparentBackground ? "md" : "auto"}
        borderWidth={hasTransparentBackground ? "1px" : "0"}
        px={3}
        py={3}
      >
        <AccordionIcon />
        <HStack as="span" direction="row" flex="1" textAlign="left">
          <Text fontWeight="bold">{title}</Text>
          {result ? <SimulationResultBadge iconOnly result={result} /> : null}
        </HStack>

        {learnMoreLink ? (
          <Link
            isExternal
            _hover={{
              textDecoration: "underline",
              textDecorationColor: "purple.500",
            }}
            href={learnMoreLink.url}
            textAlign="right"
          >
            <Text
              color="purple.500"
              display={{ base: "none", md: "block" }}
              fontSize="sm"
            >
              {learnMoreLink.label}
            </Text>
            <Text
              color="purple.500"
              display={{ base: "block", md: "none" }}
              fontSize="sm"
            >
              Learn more
            </Text>
          </Link>
        ) : undefined}
      </AccordionButton>
      <AccordionPanel p={0}>{children}</AccordionPanel>
    </AccordionItem>
  )
}

export default ReportSection
